import React, { useState } from "react";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { db, storage } from "../firebaseConfig"; // <-- адаптируйте путь к вашему config

const issueTypes = [
  "Trouble with account login",
  "Something doesn't work",
  "Security and privacy",
  "Fraud",
  "Other",
];

const Support = () => {
  // Локальные состояния для полей формы
  const [issueType, setIssueType] = useState("");
  const [email, setEmail] = useState("");
  const [description, setDescription] = useState("");
  const [file, setFile] = useState(null); // Выбранный файл
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // Функция проверки размера файла (5 MB = 5 * 1024 * 1024 = 5242880)
  const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB

  // Обработчик отправки формы
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      // 1) Проверяем обязательные поля
      if (!issueType || !email.trim() || !description.trim()) {
        setError("Please fill in required fields.");
        setLoading(false);
        return;
      }

      // 2) Если файл загружен — проверяем размер
      let fileUrl = "";
      if (file) {
        if (file.size > MAX_FILE_SIZE) {
          setError("File size cannot exceed 5MB.");
          setLoading(false);
          return;
        }

        // 2.a) Загружаем файл в Storage (папка: supportFiles/)
        const fileName = Date.now() + "-" + file.name;
        const fileRef = ref(storage, `supportFiles/${fileName}`);
        await uploadBytes(fileRef, file);
        // 2.b) Получаем ссылку
        fileUrl = await getDownloadURL(fileRef);
      }

      // 3) Создаём документ в Firestore: supportRequests
      await addDoc(collection(db, "supportRequests"), {
        issueType,
        email,
        description,
        fileUrl,           // Ссылка на файл (если есть)
        createdAt: serverTimestamp(),
      });

      // 4) Сбрасываем поля формы
      setIssueType("");
      setEmail("");
      setDescription("");
      setFile(null);
      setError("");
      setLoading(false);
      alert("Your request has been submitted successfully!");
    } catch (err) {
      console.error("Error submitting request:", err);
      setError("An error occurred while submitting your request.");
      setLoading(false);
    }
  };

  return (
    <div className="container my-5" style={{ maxWidth: "600px" }}>
      <h2 className="mb-4">Submit a request</h2>

      {error && <div className="alert alert-danger">{error}</div>}

      <form onSubmit={handleSubmit}>
        {/* What can we help with? */}
        <div className="mb-3">
          <label className="form-label" htmlFor="issueType">
            What can we help with?
          </label>
          <select
            className="form-select"
            id="issueType"
            value={issueType}
            onChange={(e) => setIssueType(e.target.value)}
          >
            <option value="">Select an issue</option>
            {issueTypes.map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>
        </div>

        {/* Email address* */}
        <div className="mb-3">
          <label className="form-label" htmlFor="email">
            Email address <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="email"
            className="form-control"
            id="email"
            placeholder="name@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        {/* Description* */}
        <div className="mb-3">
          <label className="form-label" htmlFor="description">
            Description <span style={{ color: "red" }}>*</span>
          </label>
          <textarea
            className="form-control"
            id="description"
            rows="5"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            required
          ></textarea>
        </div>

        {/* Кнопка add file */}
        <div className="mb-3">
          <label className="form-label" htmlFor="file">
            Add file (optional, max 5MB)
          </label>
          <input
            type="file"
            className="form-control"
            id="file"
            accept="image/*,.pdf,.doc,.docx" // Можно уточнить форматы
            onChange={(e) => {
              if (e.target.files[0]) {
                setFile(e.target.files[0]);
              } else {
                setFile(null);
              }
            }}
          />
        </div>

        {/* Submit button */}
        <button className="btn btn-primary" type="submit" disabled={loading}>
          {loading ? "Submitting..." : "Submit"}
        </button>
      </form>
    </div>
  );
};

export default Support;
